import React from 'react';
import { ImpContainer, ImpFlex, ImpFlexItem, ImpSpacer, ImpText, } from '../..';
const getContent = (content, text, bulletStyle) => {
    if (typeof content === 'string' || text) {
        return (React.createElement(ImpText, { typography: "body2", dataTestId: "bullet-item-text", ...bulletStyle }, content || text));
    }
    else if (content) {
        return content;
    }
};
function ImpBulletItem({ content, text, label = '•', bulletStyle, }) {
    if (text) {
        console.warn('ImpBulletItem: "text" prop is deprecated, please use "content" instead');
    }
    return (React.createElement(ImpFlex, { direction: "row", dataTestId: "bullet-item-container" },
        React.createElement(ImpFlexItem, { flex: "0 0 auto" },
            React.createElement(ImpContainer, { width: "12px" },
                React.createElement(ImpFlex, { fluid: true, align: "center", justify: "flex-start" },
                    React.createElement(ImpText, { ...bulletStyle, dataTestId: "bullet" }, label)))),
        React.createElement(ImpFlexItem, { flex: "0 0 auto" },
            React.createElement(ImpSpacer, { width: "8px" })),
        getContent(content, text, bulletStyle)));
}
export default ImpBulletItem;
//# sourceMappingURL=ImpBulletItem.js.map